/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appPortRangeValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: PortRangeValidationDirective, multi: true }]
})

export class PortRangeValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return portRangeValidation(control);
    }
}

export function portRangeValidation(control: any): any {
    const checkValue: number = (typeof control?.value === 'string') ?
        parseInt(control?.value, 10) :
        control?.value;

    // Allow port value to be null/empty. pair this with 'required' if field requires a value.
    return ((checkValue >= 1 && checkValue <= 65535) || checkValue === null) ?
        null :
        { 'portRangeValidation': 'invalid_port_range' };
}
